import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Reply {
  id: number
  user: string
  notes: string
  created_at: string
}
interface Todo {
  id: number
  title: string
}
interface Props {
  todo: Todo
  replies: Reply[]
}

export default function Index({ todo, replies }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Todos", href: "/marketing_todos" },
    { title: todo.title, href: `/marketing_todos/${todo.id}` },
    { title: "Replies", href: `/marketing_todos/${todo.id}/replies` },
  ]
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${todo.title} - Replies`} />
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Replies for {todo.title}</h1>
          <Link
            href={`/marketing_todos/${todo.id}/replies/new`}
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Reply
          </Link>
        </div>
        {replies.length > 0 ? (
          <div className="space-y-4">
            {replies.map((r) => (
              <div key={r.id} className="rounded border p-4">
                <div className="mb-2 flex justify-between">
                  <strong>{r.user}</strong>
                  <span className="text-hpi-med-gray text-sm">
                    {r.created_at}
                  </span>
                </div>
                <p className="whitespace-pre-wrap">{r.notes}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-hpi-med-gray">No replies yet.</p>
        )}
      </div>
    </AppLayout>
  )
}
